export const UPDATE_STATION_STATUS = 'UPDATE_STATION_STATUS';
export const UPDATE_STATION_DIST = 'UPDATE_STATION_DIST';
export const GET_STATION_INFO = 'GET_STATION_INFO';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const UPDATE_VALUE = 'UPDATE_VALUE';
export const UPDATE_TRIP_STATIONS = 'UPDATE_TRIP_STATIONS';